import { Construction } from "lucide-react";
import { useLocation } from "react-router-dom";
import { NAV_ITEMS } from "@/chrome/navConfig";

/**
 * 通用占位页 · Sprint 1+ 工程师按模块替换
 * 仅供路由表 91 page 全部能访问 · 不报 404
 */
export function PlaceholderPage({ title, hint }: { title?: string; hint?: string }) {
  const { pathname } = useLocation();
  const moduleItem = NAV_ITEMS.find((n) => n.to !== "/" && pathname.startsWith(n.to));
  const finalTitle = title ?? moduleItem?.labelCn ?? "页面";
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-12 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-50">
        <Construction className="h-7 w-7 text-blue-600" />
      </div>
      <h2 className="text-xl font-semibold text-slate-900">{finalTitle}</h2>
      <p className="max-w-md text-[13px] text-slate-500">
        {hint ?? "Sprint 0 Chrome 已完成 · 业务页面将在 Sprint 1+ 由各模块工程师按 canvas 实现"}
      </p>
      <code className="rounded bg-slate-100 px-3 py-1.5 text-[11px] text-slate-700">{pathname}</code>
    </div>
  );
}
